var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.component.sizes),function(image){return [(_vm.component.lazy_load)?_c('img',_vm._b({directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src(image)),expression:"src(image)"}],key:image.id},'img',_vm.imgProps(image),false)):_c('img',_vm._b({key:image.id,attrs:{"src":_vm.src(image)}},'img',_vm.imgProps(image),false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }